import styled from 'styled-components';

const MenuSpace = styled.div `
    width: 40px;
    margin-right: 82px;
`

export default MenuSpace;